import React, { useRef, useState } from "react";
import {
  Grid,
  Select,
  Button,
  MenuItem,
  TextField,
  FormControl,
  CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { validateEmail } from "../../../utils";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";

const FreeSimStatus = () => {
  const [data, setData] = useState<any>(null);
  const [email, setEmail] = useState<string>("");
  const [product, setProduct] = useState<number>(1);

  const [action, setAction] = useState<Boolean>(false);
  const agGridRef = useRef<AgGridReact | null>(null);

  const exportGridDataAsCSV = () => {
    if (agGridRef.current) {
      agGridRef.current.api.exportDataAsCsv();
    }
  };
  const onGridReady = (params: { api: { sizeColumnsToFit: () => void } }) => {
    params.api.sizeColumnsToFit();
  };
  const columnDefs: ColDef[] = [
    {
      field: "Msisdn",
      headerName: "Msisdn",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "Email",
      headerName: "Email",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "FirstName",
      headerName: "FirstName",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "LastName",
      headerName: "LastName",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "FullAddress",
      headerName: "FullAddress",
      filter: true,
      resizable: true,
      sortable: true,
    },
    {
      field: "OrderedDate",
      headerName: "OrderedDate",
      filter: true,
      sortable: true,
    },
  ];
  const handleGetBundles = async () => {
    setData(null);
    toast.dismiss();
    if (email.trim() !== "" && validateEmail(email.trim())) {
      setAction(true);
      requestBundles();
    } else {
      toast.error("Please enter valid Email");
    }
  };

  const requestBundles = async () => {
    await axiosInterceptorInstance
      .get(`/dashboard/FreeSimStatus?Email=${email.trim()}&Product=${product}`)
      .then((res: any) => {
        setAction(false);
        const apiresponse = JSON.parse(res.data.body);
        if (apiresponse.Data?.length == 0) {
          toast.error("Record not found.");
        } else {
          setData(apiresponse.Data);
        }
      })
      .catch((error: any) => {
        setAction(false);
        toast.error(error.message);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Free Sim Status</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={4.5}>
              <TextField
                className="formControl"
                label="Email"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                inputProps={{ maxLength: 40 }}
              />
            </Grid>
            <Grid item xs={4.5}>
              <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  className="formControl"
                  autoWidth
                  value={product}
                  defaultValue={product}
                  onChange={(e: any) => {
                    setProduct(parseInt(e.target.value));
                  }}
                >
                  <MenuItem value="1">THM</MenuItem>
                  <MenuItem value="2">Now</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={3}>
              {!action && (
                <Button
                  onClick={handleGetBundles}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "5px",
        }}
      >
        <button
          className="small-btn"
          style={{ visibility: data ? "visible" : "hidden" }}
          onClick={() => {
            if (data) {
              exportGridDataAsCSV();
            }
          }}
        >
          Export as CSV
        </button>
      </div>
      {data && (
        <div className="ag-theme-alpine">
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={12}
            pagination={true}
            domLayout="autoHeight"
            rowData={data}
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            enableCellTextSelection={true}
          ></AgGridReact>
        </div>
      )}
    </motion.div>
  );
};

export default FreeSimStatus;
